import React from "react";

export default function ChoiceDropdown({field,value,onChange}) {
  const selected=Array.isArray(value)?value:[];
  return <details className="hsf-choice-dropdown" style={{position:"relative"}}>
    <summary className="hsf-select" style={{cursor:"pointer",minHeight:44,listStylePosition:"inside"}} aria-label={(field.label || field.name)+": "+(selected.join(", ") || "--Select--")}>{selected.length?selected.join(", "):"--Select--"}</summary>
    <div className="hsf-check-list" role="group" aria-label={field.label || field.name} style={{position:"absolute",top:"calc(100% + 4px)",left:0,right:0,zIndex:50,boxShadow:"0 8px 24px #0f172a26",maxHeight:240,overflowY:"auto",padding:12,border:"1px solid #cbd5e1",borderRadius:8,background:"#fff",color:"#0f172a"}}>
      {(field.options || []).map(option=><label className="hsf-check-row" key={option} style={{padding:"8px 4px",cursor:"pointer"}}>
        <input type="checkbox" checked={selected.includes(option)} onChange={e=>onChange(e.target.checked?[...selected,option]:selected.filter(v=>v!==option))}/><span>{option}</span>
      </label>)}
    </div>
  </details>;
}

